import { ProductCardLayoutType } from '@eti/components';
export { ProductCardLayoutType };
export const ProductCardModalType = {
  Confirmation: 0,
  None: 1,
  Persuasion: 2
};
export const BoundValues = {
  Departing: 0,
  Returning: 1
};
//# sourceMappingURL=product.js.map